import React from 'react';
import { Wrapper } from '../common';
import { TrackingFace } from '../home';
import { MiniCartButton } from '../shop';
import { isClient } from '../../util/helpers';
import './Header.scss';

const Header = (props) => {
  const {
    navOpen,
    navIsAnimating,
    minicartOpen,
    toggleMinicartHandler,
    toggleNavHandler,
    isShop,
    isHome,
    cursorX,
    cursorY,
    viewportWidth,
    viewportHeight,
    documentHeight,
    viewportTopPos,
  } = props;
  const belowTheFold = Boolean(isClient ? viewportTopPos > window.innerHeight : false);
  return (
    <header
      className="header"
    >
      <Wrapper>
        <button
          className={`nav-button${navIsAnimating ? ' is-animating' : ''}`}
          type="button"
          aria-label="Toggle Navigation"
          onClick={event => toggleNavHandler(event)}
        >
          <span className={`label--nav-closed${!navOpen ? ' active' : ''}`}>menu</span>
          <span className={`label--nav-open${navOpen ? ' active' : ''}`}>close</span>
        </button>
        {isShop ? (
          <div className="minicart-button">
            <MiniCartButton
              minicartOpen={minicartOpen}
              toggleMinicartHandler={toggleMinicartHandler}
            />
          </div>
        ) : (
          <div className={`tracking-face${(!isHome || belowTheFold || navOpen) ? ' visible' : ''}`}>
            <TrackingFace
              cursorX={cursorX}
              cursorY={cursorY}
              viewportTopPos={viewportTopPos}
              viewportWidth={viewportWidth}
              viewportHeight={viewportHeight}
              documentHeight={documentHeight}
            />
          </div>
        )}
      </Wrapper>
    </header>
  );
};

export default Header;
